// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"565":"32fd1b21","588":"9fe2e45e"}[chunkId] + ".chunk.css";
};